// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head_video_box_item .el-carousel__container{height:33.333vw}.head_video_box_item .el-carousel__arrow--left,.head_video_box_item .el-carousel__arrow--right{width:2.604vw;height:2.604vw;background:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = exports;
